import { Shadow, Text, HStack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { FlatList } from 'native-base';
import React from 'react';

import { useProductsAdded } from '../../../../hooks';
import { flatListProps } from '../../../../utils';
import { ItemSeparator } from '../../../ItemSeparator';
import { ClearSelectionButton } from '../../../SectionWrapper/button';
import { AddedProductItemSection } from '../AddedProductItemSection';
import { Empty } from '../Empty';
import { ProductsResumeCart } from '../ProductsResumeCart';

export const AddedProducts: React.FC = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });
  const { productCartIsEmpty, resetProductCart, productAddedCart } = useProductsAdded();

  if (productCartIsEmpty) {
    return <Empty />;
  }

  return (
    <VStack mt={Spacing['stack.xxxs']} space={Spacing['stack.xxxs']} flex={1}>
      <ProductsResumeCart />
      {!isMobile && (
        <HStack alignItems="center" justifyContent="space-between">
          <Text variant="bold" color="neutral.dark" fontSize={Typography['fontsize.md']}>
            Itens adicionados
          </Text>
          <ClearSelectionButton isDisabled={productCartIsEmpty} onPress={resetProductCart} />
        </HStack>
      )}
      <Shadow level={3} flex={1}>
        <FlatList
          {...flatListProps}
          data={productAddedCart}
          keyExtractor={(item) => item.type}
          maxH="full"
          flex={1}
          ItemSeparatorComponent={ItemSeparator}
          renderItem={({ item }) => <AddedProductItemSection itemData={item} />}
        />
      </Shadow>
    </VStack>
  );
};
